import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PageMeta } from "@/components/PageMeta";

export default function NotFound() {
    return (
        <div className="container-ys section text-center">
            <PageMeta title="Page not found — YS Removals" description="The page you’re looking for could not be found." />
            <div className="mx-auto max-w-xl">
                <div className="text-[#001B3D] font-heading text-7xl sm:text-8xl font-bold">404</div>
                <h1 className="mt-2 text-3xl font-heading font-semibold">Page not found</h1>
                <p className="mt-2 text-[#17252D]/75">The page you’re looking for doesn’t exist or has moved.</p>
                <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
                    <Link to="/"><Button className="bg-[#001B3D] hover:bg-[#001B3D]/90 text-white h-11 px-6">Back to home</Button></Link>
                    <Link to="/request-a-quote"><Button variant="outline" className="h-11 px-6">Get a quote</Button></Link>
                </div>
            </div>
        </div>
    );
}
